import { actionCreatorFactory } from 'typescript-fsa';
import { ArrowType, OrderType, RecommendDesign } from '@app/react/const/type';

const actionCreator = actionCreatorFactory('selectAction');

export interface TRecommendDesignParam {
    arrowType: ArrowType;
    orderType: OrderType;
}

export interface TRecommendDesignResult {
    data: RecommendDesign[];
}

export interface TRecommendDesignError {
    message: string;
}

export const recommendDesignAction = actionCreator.async<
    TRecommendDesignParam,
    TRecommendDesignResult,
    TRecommendDesignError
>('recommendDesign');
